module.exports = __webpack_public_path__ + "media/img/old_carQ_autoplac_baner-fc499c49.png";